import { render, staticRenderFns } from "./permiss-dialog.vue?vue&type=template&id=0445085a"
import script from "./permiss-dialog.vue?vue&type=script&lang=js"
export * from "./permiss-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports